var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-top-img"},[_c('img',{staticClass:"logo-img",attrs:{"src":require("@/assets/login/logo.png")},on:{"click":_vm.go_home}})])}
var staticRenderFns = []

export { render, staticRenderFns }